// extracted by mini-css-extract-plugin
module.exports = {"col":"Col_col__18csA"};